module.exports = __webpack_public_path__ + "static/img/headaBj.9f3b59c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/headaBj.gif
// module id = x+J3
// module chunks = 89